import Ch from "./Ch";

export type OgMeta = {
  title?: string;
  description?: string;
  image?: string;
  image_width?: string;
  image_height?: string;
  url?: string;
  site_name?: string;
  type?: string;
  locale?: string;
  'fb:page_id'?: string;
};

export type TwitterMeta = {
  title?: string;
  description?: string;
  image?: string;
  card?: string;
  site?: string;
  creator?: string;
  image_alt?: string;
};

export type AppleMeta = {
  touchIcon?: string;
  app_store_id?: string;
  url?: string;
};

export type GoogleMeta = {
  title?: string;
  description?: string;
  image?: string;
  package?: string;
};

export type ChDetail = {
  id: string;
  connection: string;
  url?: string;
  resolvedUrl?: string;
  title?: string;
  description?: string;
  favicon?: string;
  canonical?: string;
  robots?: string;
  themeColor?: string;
  keywords?: string[];
  contentType?: string;
  schemaType?: string;
  fetchedAt?: string;
  fromCache?: boolean;
  error?: string;
  og?: OgMeta;
  twitter?: TwitterMeta;
  apple?: AppleMeta;
  google?: GoogleMeta;
};

export default class ChDetailModel {
  id: string;
  connection: string;
  url?: string;
  resolvedUrl?: string;
  title: string;
  description?: string;
  favicon?: string;
  canonical?: string;
  robots?: string;
  themeColor?: string;
  keywords?: string[];
  contentType?: string;
  schemaType?: string;
  fetchedAt?: string;
  fromCache?: boolean;
  error?: string;
  og?: OgMeta;
  twitter?: TwitterMeta;
  apple?: AppleMeta;
  google?: GoogleMeta;
  constructor(params: Partial<ChDetail> = init) {
    this.id = params?.id || "";
    this.connection = params?.connection || Ch.rootConnection;
    this.url = params?.url;
    this.resolvedUrl = params?.resolvedUrl;
    this.title = params?.title || '';
    this.description = params?.description;
    this.favicon = params?.favicon;
    this.canonical = params?.canonical;
    this.robots = params?.robots;
    this.themeColor = params?.themeColor;
    this.keywords = params?.keywords;
    this.contentType = params?.contentType;
    this.schemaType = params?.schemaType;
    this.fetchedAt = params?.fetchedAt;
    this.fromCache = params?.fromCache;
    this.error = params?.error;
    this.og = params?.og;
    this.twitter = params?.twitter;
    this.apple = params?.apple;
    this.google = params?.google;
  }
}

export const init: ChDetail = {
  id: "",
  connection: "",
  title: "",
  url: "",
};
